import { useState } from "react";
import { useLocation } from "react-router-dom";

import { ChevronRightIcon } from '@heroicons/react/solid'

function CollapsibleLinks(props) {
    const { children, childLinkCount, show } = props;
    const location = useLocation();

    const [showLinks, setShowLinks] = useState(children.some(child => child.props.href === location.pathname) || show);

    const handleShowLinks = () => {
        setShowLinks(showLinks => !showLinks)
    }

    return (
        <div className={"overflow-hidden"}>
            <div className={
                "flex items-center justify-between w-full hover:text-primary-600 lg:bg-white bg-transparent " +
                (children.some(child => child.props.href === location.pathname) && "text-primary-600")
            }>
                {children[0]}
                <ChevronRightIcon
                    className={
                        "block h-5 w-5 mr-4 cursor-pointer transition transition-transform transform " +
                        (showLinks && "rotate-90")
                    }
                    onClick={handleShowLinks}
                />
            </div>
            <div className={
                // (childLinkCount === 3 ? "sm:h-48" : childLinkCount === 2 ? "sm:h-32" : "sm:h-16") +
                " transition transition-height " +
                (showLinks ? childLinkCount === 3 ? "h-48" : childLinkCount === 2 ? "h-32" : "h-16" : "h-0")
            }>
                {children.slice(1).map((link) => (
                    link
                ))
                }
            </div>
        </div>
    );
}

export default CollapsibleLinks;